<template>
    <div class="l-body">
        <div class="l-menu" @click="taskEvent(taskFlag)">战绩点评</div>
        <div class="l-red" v-if="isRead"></div>
        <LTask :options="taskFlag" :list="listData" @closeTask="taskEvent(taskFlag)" />
    </div>
</template>
<script>
import LTask from "./components/l-task/l-task";
import TaskModel from './../models/task'
const taskModel = new TaskModel()
export default {
    name: "record",

    components: {
        LTask,
    },
    data() {
        return {
            taskFlag: false,
            listData: [],
            isRead: false
        };
    },

    mounted() {
        this.handleGetList()
    },
    methods: {
        taskEvent() {
            this.taskFlag = !this.taskFlag;

        },
        handleGetList() {
            taskModel.getWeekList().then(res => {
                this.listData = res.data;
                this.listData.forEach(element => {
                    if (element.readStatus === 0) {
                        this.isRead = true;
                        return
                    }
                });
            })
        }
    },
};
</script>
<style lang="stylus" scoped>
@import url('./css/index.styl');
</style>
